// extracted by mini-css-extract-plugin
export default {"starRating":"star-rating_starRating__bb5M0","star":"star-rating_star__gL+rT","disabled":"star-rating_disabled__au9t9"};